import React, { useEffect, useState } from "react";
import "./puja-campaign-child-loader.scss";
import { WiStars } from "react-icons/wi";
import starIcon from "@/../public/campaign/puja-2025/star-icon.png";
import Image from "next/image";

export default function ChildLoader() {
  return (
    <div className={`flex-col-center PujaCampaignChildLoader`}>
      <div className="loader_generator_inner">
        <span className="starIcons">
          <Image src={starIcon} alt="star icon" />
        </span>
      </div>
      <p className="flex-row-center waitTxtGenerator">
        Wait for the magic...!
        <WiStars className="iconStar" />
      </p>
    </div>
  );
}
